import React from "react";
import { BrowserRouter as Router, Routes, Route } from "react-router-dom";
import Footer from "../Navigation/BottomNavigation/Footer";
import Navbar from "../Navigation/TopNavigation/Navbar";
import HomePage from "../Navigation/Content/HomePage";
import AllProductBikes from "../MainCategory/ProductBikes/AllProductBikes";
import SingleProductBikes from "../MainCategory/ProductBikes/SingleProductBikes";
import SingleProductCars from "../MainCategory/ProductCars/SingleProductCars";
import SingleProductCycles from "../MainCategory/ProductCycles/SingleProductCycles";
import SingleProductsToys from "../MainCategory/ProductToys/SingleProductsToys";
import SingleProductGiftsAndArts from "../MainCategory/ProductGiftsAndArts/SingleProductGiftsAndArts";
import AllProductCars from "../MainCategory/ProductCars/AllProductCars";
import AllProductCycles from "../MainCategory/ProductCycles/AllProductCycles";
import AllProductsGiftsAndArts from "../MainCategory/ProductGiftsAndArts/AllProductsGiftsAndArts";
import AllProductsToys from "../MainCategory/ProductToys/AllProductsToys";
import AboutPage from "../Navigation/Content/AboutPage";
import ContactUsPage from "../Navigation/Content/ContactUsPage";
import PrivacyPolicies from "../Navigation/BottomNavigation/PrivacyPolicies";
import TermsAndConditions from "../Navigation/BottomNavigation/TermsAndConditions";
import ShippingPolicies from "../Navigation/BottomNavigation/ShippingPolicies";
import ReturnAndExchange from "../Navigation/BottomNavigation/ReturnAndExchange";
import LoginPage from "../MainCategory/CommonPages/LoginPage";
import AdmnDashboard from "../MainCategory/CommonPages/AdmnDashboard";
import TabviewAllProducts from "../MainCategory/CommonPages/TabviewAllProducts";

function PageRouter() {
  return (
    <Router>
      <Navbar />
      <Routes>
        
          <Route path="/" element={<HomePage />} />
        

        <Route path="/AboutUs" element={<AboutPage />} />
        <Route path="/contact" element={<ContactUsPage />} />
        {/* Footer links */}
        <Route path="/privacypolicy" element={<PrivacyPolicies />} />
        <Route path="/TermsOfService" element={<TermsAndConditions />} />
        <Route path="/ShippingPolicy" element={<ShippingPolicies />} />
        <Route path="/ReturnsExchanges" element={<ReturnAndExchange />} />
        {/* Single Product Links */}
        <Route path="/carsById/:id" element={<SingleProductCars />} />
        <Route path="/bikesById/:id" element={<SingleProductBikes />} />
        <Route path="/productcycles/:id" element={<SingleProductCycles />} />
        <Route path="/toysById/:id" element={<SingleProductsToys />} />
        <Route path="/product/:id" element={<TabviewAllProducts />} />
        <Route
          path="/giftsAndArtsById/:id"
          element={<SingleProductGiftsAndArts />}
        />
        {/* All Products Link */}
        <Route path="/productsCars" element={<AllProductCars />} />
        <Route path="/productsBikes" element={<AllProductBikes />} />
        <Route path="/productsCycles" element={<AllProductCycles />} />
        <Route path="/productsToys" element={<AllProductsToys />} />
        <Route
          path="/productsGiftsAndArts"
          element={<AllProductsGiftsAndArts />}
        />
        {/* Login And Dashboard paths */}
        <Route path="/LoginPage" element={<LoginPage />} />
        <Route path="/Dashboard" element={<AdmnDashboard />} />
        <Route path="/contact" element={<ContactUsPage />} />
      </Routes>
      <Footer />
    </Router>
  );
}

export default PageRouter;
